import {Injectable} from "@angular/core";
import {CatalogResource, CatalogsService} from "../core/modules/openapi";
import {Observable, of} from "rxjs";
import {tap, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // store cached insurers in-memory as well as localStorage
  private readonly insurers: Map<string, CatalogResource> = new Map();

  constructor(private readonly catalogService: CatalogsService) {}

  getInsurers(): Observable<CatalogResource[]> {
    const stored = localStorage.getItem("insurers");
    if (stored) {
      const insurersList: CatalogResource[] = JSON.parse(stored);
      insurersList.forEach(insurer => {
        if (insurer.code) {
          this.insurers.set(insurer.code, insurer);
        }
      });
      return of(insurersList);
    } else {
      return this.catalogService.getCatalogData("insurers", "").pipe(
        tap(response => {
          response.forEach(insurer => {
            if (insurer.code) {
              this.insurers.set(insurer.code, insurer);
            }
          });
          localStorage.setItem("insurers", JSON.stringify(response));
        })
      );
    }
  }

  getInsurersMap(): Observable<Map<string, CatalogResource>> {
    if (this.insurers.size === 0) {
      // return an observable that waits for getInsurers to emit and then maps to the insurers map
      return this.getInsurers().pipe(map(() => this.insurers));
    }
    // already cached: return immediately as an observable
    return of(this.insurers);
  }
}
